<template>
  <div>
    <!-- 诊所异常诊断列表页签 -->
    <el-tabs v-model="activeName" style="margin-top: 10px;margin-left: 10px" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="tab in tabConfig"
        :key="tab.name"
        :label="tab.label"
        :name="tab.name"
        :lazy="true"
      >
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" shadow="hover">
                <!-- 卡片头部保持原样式占位 -->
                <div slot="header" class="clearfix" style="border: none"></div>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-table
                      :ref="`table_${tab.name}`"
                      :data="getTableData(tab)"
                      :height="tableHeight"
                      :header-cell-style="tableHeaderStyle"
                      :row-class-name="tableRowClassName"
                      :style="tab.tableStyle || tableStyle"
                    >
                      <!-- 公共序号列 -->
                      <el-table-column type="index" label="序号" align="center"></el-table-column>
                      <template v-for="column in tab.columns">
                        <el-table-column
                          v-if="!column.hidden && column.type !== 'action'"
                          :key="column.prop"
                          :prop="column.prop"
                          :sortable="column.sortable"
                          :label="column.label"
                          :show-overflow-tooltip="column.tooltip"
                          :formatter="getColumnFormatter(column)"
                        ></el-table-column>
                        <!-- 操作列：打开诊所详情 -->
                        <el-table-column v-else-if="column.type === 'action'" :key="column.label" :label="column.label">
                          <template slot-scope="scope">
                            <el-button
                              @click="open_detail(scope.row)"
                              type="text"
                              :style="actionButtonStyle"
                              size="small"
                            >
                              详情
                            </el-button>
                          </template>
                        </el-table-column>
                      </template>
                    </el-table>
                  </el-col>
                </el-row>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>


  </div>
</template>

<script>
import '@/assets/css/main.css';
import { buildAppWebUrl } from '@/utils/appWebUrl';

// 表格通用样式/尺寸配置（保留原颜色）
const TABLE_HEADER_STYLE = { background: '#363944', color: 'white', border: 'none' };
const TABLE_HEIGHT = '600px';
const ACTION_BUTTON_STYLE = 'color: rgb(46, 205, 129);';
const TABLE_STYLE = { width: '100%' };

// 诊所消沉列表列配置
const CLINIC_ABSENT_COLUMNS = [
  { prop: 'clinic_id', label: '诊所ID', sortable: true, hidden: true },
  { prop: 'clinic_name', label: '诊所名称', sortable: true, tooltip: true },
  { prop: 'clinic_phone', label: '电话', sortable: true },
  { prop: 'province', label: '省份', sortable: true },
  { prop: 'city', label: '城市', sortable: true },
  { prop: 'area', label: '地区', sortable: true },
  { prop: 'create_time', label: '最近时间', sortable: true },
  { type: 'action', label: '操作' },
];

// 诊所收入异常列表列配置
const CLINIC_ABNORMAL_COLUMNS = [
  { prop: 'clinic_id', label: '诊所ID', sortable: true, hidden: true },
  { prop: 'clinic_name', label: '诊所名称', sortable: true, tooltip: true },
  { prop: 'clinic_phone', label: '电话', sortable: true },
  { prop: 'province', label: '省份', sortable: true },
  { prop: 'city', label: '城市', sortable: true },
  { prop: 'area', label: '地区', sortable: true },
  { type: 'action', label: '操作' },
];

// 区域收入异常列表列配置
const AREA_ABNORMAL_COLUMNS = [
  { prop: 'province', label: '省份', sortable: true, tooltip: true },
  { prop: 'city', label: '城市', sortable: true },
  { prop: 'area', label: '地区', sortable: true },
  { prop: 'value', label: '最近一个月收入（元）', sortable: true, formatter: 'formatMoney' },
];

// 页签配置：与后端数据字段、拉取方法一一对应
const TAB_CONFIG = [
  {
    label: '云诊所消沉列表',
    name: 'first',
    dataKey: 'recent_absent_clinics_online_list',
    fetchMethod: 'getRecent_absent_clinics_online_list',
    columns: CLINIC_ABSENT_COLUMNS,
  },
  {
    label: 'Pad诊所消沉列表',
    name: 'second',
    dataKey: 'recent_absent_clinics_pad_list',
    fetchMethod: 'getRecent_absent_clinics_pad_list',
    columns: CLINIC_ABSENT_COLUMNS,
    tableStyle: { width: '100%' },
  },
  {
    label: '诊所收入异常列表',
    name: 'third',
    dataKey: 'recent_abnormal_clinic_fees',
    fetchMethod: 'getRecent_abnormal_clinic_fees',
    columns: CLINIC_ABNORMAL_COLUMNS,
    tableStyle: { width: '100%' },
  },
  {
    label: '区域收入异常列表',
    name: 'fourth',
    dataKey: 'recent_abnormal_area_fees',
    fetchMethod: 'getRecent_abnormal_area_fees',
    columns: AREA_ABNORMAL_COLUMNS,
    tableStyle: { width: '100%' },
  },
];

export default {
  name: "DiagnoseView",
  data() {
    return {
      // 当前页签
      activeName: "first",
      // 表格数据源
      recent_absent_clinics_online_list: null,
      recent_absent_clinics_pad_list: null,
      recent_abnormal_clinic_fees: null,
      recent_abnormal_clinic_kfsl: null,
      recent_abnormal_area_fees: null,
      recent_abnormal_area_kfsl: null,
      // 页签/表格配置
      tabConfig: TAB_CONFIG,
      tableHeight: TABLE_HEIGHT,
      tableHeaderStyle: TABLE_HEADER_STYLE,
      actionButtonStyle: ACTION_BUTTON_STYLE,
      tableStyle: TABLE_STYLE,
      /** 已请求过数据的页签 name，避免重复请求；若要每次切换都刷新可改为在 loadTabData 里去掉判断 */
      tabsDataLoaded: {},
    }
  },
  mounted() {
    /** 仅加载默认激活页签，其余在点击时再请求 */
    this.loadTabData(this.activeName)
  },
  methods: {
    formatMoney(row){
      // 金额格式化（千分位，两位小数）
      return parseInt(row.value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    getColumnFormatter(column) {
      // 表格列配置转换为 formatter 函数
      if (!column.formatter) {
        return undefined;
      }
      return this[column.formatter];
    },
    getTableData(tab) {
      // 从配置中读取对应的数据源
      return this[tab.dataKey];
    },
    open_detail(row) {
      // 打开诊所详情页（VUE_APP_WEB_HOST 未配置时避免 undefined 拼进 URL）
      window.open(
        buildAppWebUrl(`/clinic/clinic_info?doctor_id=-1&clinic_id=${row.clinic_id}`),
        '_blank',
        'noopener,noreferrer'
      );
    },
    getRecent_absent_clinics_online_list() {
      // 获取云诊所消沉列表
      return this.$http.get(process.env.VUE_APP_API_HOST + "/recent_absent_clinics_online").then((res) => {
        this.recent_absent_clinics_online_list = res.data.data;
      })
    },
    getRecent_absent_clinics_pad_list() {
      // 获取Pad诊所消沉列表
      return this.$http.get(process.env.VUE_APP_API_HOST + "/recent_absent_clinics_pad").then((res) => {
        this.recent_absent_clinics_pad_list = res.data.data;
      })
    },
    getRecent_abnormal_clinic_fees() {
      // 获取诊所收入异常列表
      return this.$http.get(process.env.VUE_APP_API_HOST + "/recent_abnormal_clinic_fees").then((res) => {
        this.recent_abnormal_clinic_fees = res.data.data;
      })
    },
    getRecent_abnormal_clinic_kfsl() {
      // 获取诊所开方异常列表（当前无页签，保留方法供扩展）
      return this.$http.get(process.env.VUE_APP_API_HOST + "/recent_abnormal_clinic_kfsl").then((res) => {
        this.recent_abnormal_clinic_kfsl = res.data.data;
      })
    },
    getRecent_abnormal_area_fees() {
      // 获取区域收入异常列表
      return this.$http.get(process.env.VUE_APP_API_HOST + "/recent_abnormal_area_fees").then((res) => {
        this.recent_abnormal_area_fees = res.data.data;
      })
    },
    getRecent_abnormal_area_kfsl() {
      // 获取区域开方异常列表（当前无页签，保留方法供扩展）
      return this.$http.get(process.env.VUE_APP_API_HOST + "/recent_abnormal_area_kfsl").then((res) => {
        this.recent_abnormal_area_kfsl = res.data.data;
      })
    },

    /**
     * 按页签拉取列表：每个 tab 首次展示时请求一次对应接口，已加载则只重排表格
     * @param {string} tabName - el-tab-pane 的 name，与 TAB_CONFIG.name 一致
     */
    loadTabData(tabName) {
      const cfg = this.tabConfig.find((t) => t.name === tabName)
      if (!cfg || !cfg.fetchMethod) {
        this.layoutTableForTab(tabName)
        return
      }
      if (this.tabsDataLoaded[tabName]) {
        this.layoutTableForTab(tabName)
        return
      }
      const fn = this[cfg.fetchMethod]
      if (typeof fn !== 'function') {
        this.layoutTableForTab(tabName)
        return
      }
      Promise.resolve(fn.call(this))
        .then(() => {
          this.$set(this.tabsDataLoaded, tabName, true)
          this.layoutTableForTab(tabName)
        })
        .catch(() => {
          this.layoutTableForTab(tabName)
        })
    },
    /**
     * 当前页签表格 doLayout，避免切换后列宽异常
     * @param {string} tabName
     */
    layoutTableForTab(tabName) {
      this.$nextTick(() => {
        const tableRef = this.$refs[`table_${tabName}`]
        const tableRefs = Array.isArray(tableRef) ? tableRef : [tableRef]
        tableRefs.forEach((item) => {
          if (item && item.doLayout) {
            item.doLayout()
          }
        })
      })
    },

    tableRowClassName({ rowIndex }) {
      // 表格隔行配色（保留原样式）
      if (rowIndex % 2 == 1) {
        return 'warning-row1';
      } else if (rowIndex % 2 == 0) {
        return 'success-row1';
      }
      return '';
    },
    handleTabClick(tab) {
      /** 切换页签时再请求该 tab 对应接口（首次），避免进入页面一次拉齐所有列表 */
      this.loadTabData(tab.name)
    },

  },
}
</script>

<style scoped>
.el-table /deep/ tbody tr:hover {
  color: black !important
}

.el-table /deep/ .warning-row1 {
  background: #363944;
}

.el-table /deep/ .warning-row1 > td {
  border: none;
}

.el-table /deep/ .success-row1 {
  background: #3C3F4A;
}

.el-table /deep/ .success-row1 > td {
  border: none;
}

.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}


::v-deep .el-tabs__item {
  color: white !important;
  font-size: 20px;
}

::v-deep .el-tabs__item.is-active {
  color: white !important;
  font-size: 20px;
}

::v-deep .el-tabs__active-bar {
  background-color: #68F5B9 !important;

}
.el-table /deep/ .el-table__expanded-cell {
  background-color: #3C3F4A !important;
}
</style>
